import React, { useState, useEffect } from 'react';
import AdminLayout from '../../components/AdminLayout';
import api from '../../api';

const GOLD = '#D4AF37';
const BG_CARD = '#0d1117';
const BORDER = 'rgba(255,255,255,0.07)';
const TEXT_SEC = '#6b7280';
const INPUT_BG = '#0a0f1e';

const cardStyle = { background: BG_CARD, border: `1px solid ${BORDER}`, borderRadius: 16, padding: 24, marginBottom: 16 };
const inputStyle = { width: '100%', background: INPUT_BG, border: '1px solid rgba(255,255,255,0.1)', borderRadius: 10, padding: '12px', color: '#fff', fontSize: 14, outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit' };
const btnGold = { background: GOLD, color: '#000', border: 'none', borderRadius: 10, padding: '12px 20px', fontWeight: 700, fontSize: 14, cursor: 'pointer' };
const btnGhost = { background: 'transparent', color: TEXT_SEC, border: `1px solid ${BORDER}`, borderRadius: 8, padding: '8px 14px', fontSize: 13, fontWeight: 600, cursor: 'pointer' };

const EMPTY = { name: '', description: '', service_id: '', total_sessions: 5, price: '', is_active: true };

export default function Packages() {
  const [packages, setPackages] = useState([]);
  const [services, setServices] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(EMPTY);
  const [toast, setToast] = useState('');

  useEffect(() => {
    load();
    api.get('/services').then(r => setServices(r.data.filter(s => s.active !== false))).catch(() => {});
  }, []);

  function load() { api.get('/packages').then(r => setPackages(r.data)).catch(() => {}); }
  function showToast(msg) { setToast(msg); setTimeout(() => setToast(''), 3000); }

  function openCreate() { setForm(EMPTY); setEditing(null); setShowModal(true); }
  function openEdit(pkg) { setForm({ ...pkg, service_id: pkg.service_id || '' }); setEditing(pkg.id); setShowModal(true); }

  async function save(e) {
    e.preventDefault();
    try {
      if (editing) {
        await api.put(`/packages/${editing}`, form);
      } else {
        await api.post('/packages', form);
      }
      setShowModal(false);
      load();
      showToast(editing ? 'Package updated!' : 'Package created!');
    } catch { showToast('Error saving package'); }
  }

  async function del(id) {
    if (!window.confirm('Delete package?')) return;
    try { await api.delete(`/packages/${id}`); load(); showToast('Deleted'); } catch { showToast('Error'); }
  }

  return (
    <AdminLayout>
      {toast && (
        <div style={{ position: 'fixed', top: 20, right: 20, background: BG_CARD, border: `1px solid ${GOLD}`, color: GOLD, padding: '12px 20px', borderRadius: 10, zIndex: 9999, fontWeight: 600, fontSize: 14 }}>{toast}</div>
      )}

      <div style={{ maxWidth: 800 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
          <div>
            <h1 style={{ color: '#fff', fontSize: 24, fontWeight: 800, margin: 0 }}>Packages</h1>
            <p style={{ color: TEXT_SEC, fontSize: 14, margin: '4px 0 0' }}>Bundle deals for your clients</p>
          </div>
          <button style={btnGold} onClick={openCreate}>+ New Package</button>
        </div>

        {/* Modal */}
        {showModal && (
          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
            <div style={{ ...cardStyle, width: '100%', maxWidth: 500, marginBottom: 0 }}>
              <h3 style={{ color: GOLD, margin: '0 0 20px', fontSize: 16 }}>{editing ? 'Edit Package' : 'New Package'}</h3>
              <form onSubmit={save}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                  <div>
                    <label style={{ color: TEXT_SEC, fontSize: 12, fontWeight: 600, display: 'block', marginBottom: 6 }}>PACKAGE NAME *</label>
                    <input style={inputStyle} value={form.name} onChange={e => setForm({...form, name: e.target.value})} required placeholder="e.g. 5-Cut Bundle" />
                  </div>
                  <div>
                    <label style={{ color: TEXT_SEC, fontSize: 12, fontWeight: 600, display: 'block', marginBottom: 6 }}>DESCRIPTION</label>
                    <textarea style={{ ...inputStyle, height: 80, resize: 'vertical' }} value={form.description || ''} onChange={e => setForm({...form, description: e.target.value})} placeholder="What's included..." />
                  </div>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
                    <div>
                      <label style={{ color: TEXT_SEC, fontSize: 12, fontWeight: 600, display: 'block', marginBottom: 6 }}>SERVICE</label>
                      <select style={inputStyle} value={form.service_id} onChange={e => setForm({...form, service_id: e.target.value})}>
                        <option value="">Any</option>
                        {services.map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
                      </select>
                    </div>
                    <div>
                      <label style={{ color: TEXT_SEC, fontSize: 12, fontWeight: 600, display: 'block', marginBottom: 6 }}>SESSIONS</label>
                      <input style={inputStyle} type="number" min="1" value={form.total_sessions} onChange={e => setForm({...form, total_sessions: parseInt(e.target.value)})} required />
                    </div>
                    <div>
                      <label style={{ color: TEXT_SEC, fontSize: 12, fontWeight: 600, display: 'block', marginBottom: 6 }}>PRICE *</label>
                      <input style={inputStyle} type="number" step="0.01" min="0" value={form.price} onChange={e => setForm({...form, price: e.target.value})} required placeholder="99.00" />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'flex-end', paddingBottom: 4 }}>
                      <label style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', color: TEXT_SEC, fontSize: 13 }}>
                        <input type="checkbox" checked={form.is_active} onChange={e => setForm({...form, is_active: e.target.checked})} />
                        Active
                      </label>
                    </div>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 12, marginTop: 24 }}>
                  <button type="submit" style={btnGold}>{editing ? 'Save Changes' : 'Create Package'}</button>
                  <button type="button" style={btnGhost} onClick={() => setShowModal(false)}>Cancel</button>
                </div>
              </form>
            </div>
          </div>
        )}

        <div style={{ display: 'grid', gap: 12 }}>
          {packages.length === 0 ? (
            <div style={{ ...cardStyle, textAlign: 'center', padding: '48px 24px' }}>
              <div style={{ fontSize: 40, marginBottom: 12, color: TEXT_SEC }}>—</div>
              <p style={{ color: TEXT_SEC }}>No packages yet. Create your first bundle deal!</p>
            </div>
          ) : packages.map(pkg => (
            <div key={pkg.id} style={{ ...cardStyle, marginBottom: 0, display: 'flex', alignItems: 'center', gap: 16 }}>
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
                  <span style={{ color: '#fff', fontWeight: 700, fontSize: 16 }}>{pkg.name}</span>
                  {!pkg.is_active && <span style={{ color: TEXT_SEC, background: 'rgba(255,255,255,0.05)', borderRadius: 4, padding: '1px 8px', fontSize: 11 }}>INACTIVE</span>}
                </div>
                {pkg.description && <p style={{ color: TEXT_SEC, fontSize: 13, margin: '0 0 6px' }}>{pkg.description}</p>}
                <div style={{ display: 'flex', gap: 16, color: TEXT_SEC, fontSize: 12 }}>
                  <span>{pkg.total_sessions} sessions</span>
                  {pkg.service_name && <span>{pkg.service_name}</span>}
                  <span style={{ color: GOLD, fontWeight: 700 }}>${parseFloat(pkg.price).toFixed(2)}</span>
                </div>
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button style={{ ...btnGhost, fontSize: 12 }} onClick={() => openEdit(pkg)}>Edit</button>
                <button style={{ ...btnGhost, color: '#ef4444', borderColor: '#ef444444', fontSize: 12 }} onClick={() => del(pkg.id)}>Delete</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </AdminLayout>
  );
}
